module.exports = require('./helpers/bundle-url').getBundleURL('jZAn8') + "logo-dark.eefe0b7f.svg";